import {
  Autocomplete,
  TextField,
  Link,
  Popper,
  Box,
  Paper,
  Typography,
} from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

function AutoCompleteContext({
  name,
  label,
  getOptionLabel = () => {},
  options,
  onChangeCallback = () => {},
  handleNavigateAddNewCustomer = () => {},
  typeData,
  ...rest
}) {
  const { getFieldProps, getFieldMeta, setFieldValue } = useFormikContext();
  const fieldProps = getFieldProps(name);
  const fieldMeta = getFieldMeta(name);

  return (
    <Autocomplete
      {...fieldProps}
      {...rest}
      id={name}
      noOptionsText="Sem opções"
      openText="Abrir"
      closeText="Fechar"
      clearText="Limpar"
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={(event, newValue) => {
        setFieldValue(name, newValue);
        onChangeCallback(newValue);
      }}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          fullWidth
          error={fieldMeta.touched && fieldMeta.error}
          helperText={fieldMeta.touched && fieldMeta.error}
        />
      )}
      PopperComponent={(param) => (
        <Popper {...param}>
          <Box {...param} />

          {typeData && (
            <Paper>
              <Typography style={{ padding: '1rem', color: 'gray' }}>
                <Link
                  style={{ cursor: 'pointer' }}
                  color="primary"
                  onMouseDown={handleNavigateAddNewCustomer}
                >
                  + Cadastrar um cliente
                </Link>
              </Typography>
            </Paper>
          )}
        </Popper>
      )}
    />
  );
}

export default AutoCompleteContext;
